import Vue from 'vue';
import {
  GAMES_REQUEST,
  GAMES_SUCCESS,
  GAMES_ERROR,
  LAUNCH_GAME_REQUEST,
  LAUNCH_GAME_SUCCESS,
  LAUNCH_GAME_ERROR,
} from '../actions/games';
import {
  BASE_URL,
  GET_GAMES,
  LAUNCH_GAME,
  M_POST,
} from '../../utils/api';
import { EventBus } from '../../services/event-bus';

/* eslint-disable */
const state = {
  status: ''
}


const actions = {
  [GAMES_REQUEST]: ({commit}) => {
    return new Promise((resolve, reject) => {
      commit(GAMES_REQUEST)
      Vue.axios({url: BASE_URL + GET_GAMES, method: M_POST})
        .then(resp => {
          let result = resp.data
          if (result.status.code === 0) {
            commit(GAMES_SUCCESS)
            resolve(result.data)
          } 
          if (result.status.code === 1002){
            // Vue.prototype.$session.destroy()
            delete Vue.axios.defaults.headers.common['Authorization']
            EventBus.$emit('logOut')
            EventBus.$emit('getgame')
            throw result.status.code
            // localStorage.clear()
            // delete Vue.axios.defaults.headers.common['Authorization']
          }
          else {
            throw result.status.message
          }
        })
        .catch(err => {
          commit(GAMES_ERROR, err)
          reject(err)
        })
    })
  },

  [LAUNCH_GAME_REQUEST]: ({commit, dispatch}, prefix) => {
    return new Promise((resolve, reject) => {
      commit(LAUNCH_GAME_REQUEST)
      Vue.axios({url: BASE_URL + LAUNCH_GAME, data:prefix, method: M_POST})
        .then(resp => {
          let result = resp.data
          if (result.status.code === 0) {
            commit(LAUNCH_GAME_SUCCESS)
            resolve(result.data)
          } 
          if (result.status.code === 1002){
            // Vue.prototype.$session.destroy()
            delete Vue.axios.defaults.headers.common['Authorization']
            EventBus.$emit('logOut')
            EventBus.$emit('getgame')
            throw result.status.code
            // localStorage.clear()
            // delete Vue.axios.defaults.headers.common['Authorization']
          }
          else {
            throw result.status.message
          }
        })
        .catch(err => {
          commit(LAUNCH_GAME_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [GAMES_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [GAMES_SUCCESS]: (state) => {
    state.status = 'success'
  },
  [GAMES_ERROR]: (state) => {
    state.status = 'error'
  },
  [LAUNCH_GAME_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [LAUNCH_GAME_SUCCESS]: (state) => {
    state.status = 'success'
  },
  [LAUNCH_GAME_ERROR]: (state) => {
    state.status = 'error'
  },
}

export default {
  state,
  actions,
  mutations,
}
